import React from 'react';
import {Role} from '../utils/roles';
import Dashboard from './pages/Dashboard.js';
import Carte from './pages/Carte.js';
import FichePav from './pages/FichePav.js';
import GardeModule from './components/GardeModule.js';

// Routes du module Pilotage (PIL-01). `protected: false` = rendu plein écran par Layout (sans en-tête ni tiroir extranet) ; l'accès est gardé par GardeModule. Pas d'entrée de menu (`tiles` absent). Flag : VITE_PILOTAGE_ENABLED.
// Flag VITE_PILOTAGE_ENABLED : si différent de 'true', aucune route n'est enregistrée (NotFound).
const ACTIF = import.meta.env.VITE_PILOTAGE_ENABLED === 'true';

export const PILOTAGE_ROUTES = !ACTIF ? [] : [
    {exact: true, protected: false, path: '/pilotage/:slug', roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT], element: <GardeModule><Dashboard/></GardeModule>},
    {exact: true, protected: false, path: '/pilotage/:slug/carte', roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT], element: <GardeModule><Carte/></GardeModule>},
    {exact: true, protected: false, path: '/pilotage/:slug/pav/:pavId', roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT], element: <GardeModule><FichePav/></GardeModule>},
];
